import React, { FC } from "react";
import type { EndUserAppsEngageWithUsersProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const EndUserAppsEngageWithUsers: FC<
  EndUserAppsEngageWithUsersProps
> = ({ content, cover }) => {
  return (
    <section className="endUserAppsEngageWithUsers">
      <div className="wrapper">
        <TextCols content={content} size="md" maxTitleWidth={760} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="endUserAppsEngageWithUsers--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
